/*
 * @Author: kangkang 1278279046@qq.com
 * @Date: 2022-06-27 15:24:26
 * @LastEditors: kangkang 1278279046@qq.com
 * @LastEditTime: 2022-06-27 15:33:31
 * @FilePath: \experience-pc\src\util\cryptoDES.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 登录des对称加密
import CryptoJs from 'crypto-js'
import util from './util'
export default {
    
  /**
   * 加密
   */
   encrypt(word) {
    let key = CryptoJs.enc.Utf8.parse(util.DES_KEY);
    let srcs = CryptoJs.enc.Utf8.parse(word);
    // 如果要用AES加密，就将下面这行DES改成AES 解密同理
    let encrypted = CryptoJs.DES.encrypt(srcs, key, {
      mode: CryptoJs.mode.ECB,
      padding: CryptoJs.pad.Pkcs7
    });
    return encrypted.toString();
  },

  /**
   * 解密
   */
   decrypt(word) {
    let key = CryptoJs.enc.Utf8.parse(util.DES_KEY);
    // 如果要用AES解密，就将下面这行DES改成AES 加密同理
    let decrypt = CryptoJs.DES.decrypt(word, key, {
      mode: CryptoJs.mode.ECB,
      padding: CryptoJs.pad.Pkcs7
    });
    return CryptoJs.enc.Utf8.stringify(decrypt).toString();
  }
}



// WEBPACK FOOTER //
// ./src/util/cryptoDES.js